module.exports = __webpack_public_path__ + "static/media/seed3.2f8f4813.png";